import $ from "jquery";

$(function () {
  /** GA4 Trigger - Call Us Click **/
  $(".track-call-us").on("click", function () {
    console.log($(this));
    window.dataLayer.push({
      event: "call_us_click",
    });
  });
  /** GA4 Trigger - Email Address Click **/
  $(".track-email").on("click", function () {
    console.log($(this));
    window.dataLayer.push({
      event: "email_address_click",
    });
  });
  /** GA4 Trigger - Brochure Download Click **/
  $(".track-brochure").on("click", function () {
    console.log($(this));
    window.dataLayer.push({
      event: "brochure_download_click",
    });
  });
});
